// extracted by mini-css-extract-plugin
export default {"DataBox":"AosAdnetwork_DataBox__Oxe3w","firstAdsflatform":"AosAdnetwork_firstAdsflatform__+3iPP"};